export default "__VITE_ASSET__Dl4tw8YP__"